import { Card, CardContent, CardHeader, CardTitle, cn } from '@repo/shadcn';

import { formatCurrencyInBDT } from '@/utils';
import { mapPaymentMethodEnumToString } from '@/utils/mappers';

type TransactionHistoryProps = {
    transactions?: Array<any>;
};

export const TransactionHistory = ({
    transactions,
}: TransactionHistoryProps) => {
    const renderContent = () => {
        if (!transactions) {
            return (
                <tr>
                    <td
                        colSpan={5}
                        className={'flex items-center justify-center px-4 py-6'}
                    >
                        No transaction data available.
                    </td>
                </tr>
            );
        }

        if (transactions.length === 0) {
            return (
                <tr>
                    <td
                        colSpan={5}
                        className={'flex items-center justify-center px-4 py-6'}
                    >
                        No transactions found.
                    </td>
                </tr>
            );
        }

        return transactions.map((tx, index) => {
            const date = new Date(tx.created_at);
            const timeString = date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
            });

            const amount = formatCurrencyInBDT(Math.abs(tx.amount));
            const isNegativeAmount = tx.amount < 0;

            const dateString = date.toLocaleDateString();
            return (
                <tr key={index} className="border-b hover:bg-muted/50">
                    <td className="px-4 py-3 text-sm">{dateString}</td>
                    <td className="px-4 py-3 text-sm">{timeString}</td>
                    <td
                        className={cn(
                            'px-4 py-3 text-right font-semibold',
                            isNegativeAmount && 'text-red-500',
                        )}
                    >
                        {amount}
                    </td>
                    <td className="px-4 py-3 text-sm text-muted-foreground">
                        {mapPaymentMethodEnumToString(tx.payment_method ?? '')}
                    </td>

                    <td className="px-4 py-3 text-sm text-muted-foreground">
                        {tx.transaction_id}
                    </td>

                    <td>{tx.note}</td>
                </tr>
            );
        });
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-lg">Transaction History</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b">
                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Date
                                </th>
                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Time
                                </th>
                                <th className="px-4 py-3 text-right font-semibold text-muted-foreground">
                                    Amount
                                </th>

                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Payment Method
                                </th>

                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Transaction ID
                                </th>

                                <th className={'text-left'}>Note</th>
                            </tr>
                        </thead>
                        <tbody>{renderContent()}</tbody>
                    </table>
                </div>
            </CardContent>
        </Card>
    );
};
TransactionHistory.displayName = 'TransactionHistory';
